import React, { Component } from 'react';
import { Tabs, Tab } from 'react-mdl';
import PageShell from './PageShell';
import ProjectCards from './ProjectCards';
import { PROJECT_CATEGORIES } from '../data/projectPortfolio';

class Projects extends Component {
    constructor(props) {
        super(props);
        this.state = { activeTab: 0 };
    }

    renderCategoryContext(category) {
        return (
            <div className="category-context">
                <h2 className="category-headline">{category.headline}</h2>
                <p className="category-overview">{category.overview}</p>
                <div className="category-focus">
                    <span className="category-focus-label">Focus areas</span>
                    <ul className="category-focus-list">
                        {category.focusAreas.map((area) => (
                            <li key={area}>{area}</li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }

    renderProjectCards(projects) {
        return (
            <div className="projects-grid">
                {projects.map((project) => (
                    <ProjectCards key={project.id} {...project} />
                ))}
            </div>
        );
    }

    renderActiveCategory() {
        const category = PROJECT_CATEGORIES[this.state.activeTab];
        if (!category) {
            return null;
        }

        return (
            <>
                {this.renderCategoryContext(category)}
                {this.renderProjectCards(category.projects)}
            </>
        );
    }

    render() {
        return (
            <PageShell
                title="Projects & Engagements"
                subtitle="Enterprise solution design across banking, telecom, and cloud transformation programs."
                className="page-projects"
            >
                <div className="category-tabs">
                    <div className="tabs-scroll">
                        <Tabs
                            activeTab={this.state.activeTab}
                            onChange={(tabId) => this.setState({ activeTab: tabId })}
                            ripple
                        >
                            {PROJECT_CATEGORIES.map((category) => (
                                <Tab key={category.id}>{category.label}</Tab>
                            ))}
                        </Tabs>
                    </div>

                    <section className="category-content">
                        {this.renderActiveCategory()}
                    </section>
                </div>
            </PageShell>
        );
    }
}

export default Projects;
